export const juniorSecurityEngineerResume = `
【職務概要】
セキュリティエンジニアとして約3年の実務経験を持ち、主に脆弱性診断、セキュリティ監視・運用、インシデント対応の分野を専門としています。Microsoft 365セキュリティ製品群や各種SIEM/EDRツールの実装・運用経験を通じて、日々進化するサイバー脅威への対応力を磨いてきました。

特にSOC運用とインシデントレスポンスに強みを持ち、組織のセキュリティ体制強化に貢献してきた実績があります。また、最新のサイバーセキュリティ動向や攻撃手法に関する知識を常にアップデートし、Azure SentinelやMicrosoft Defender for Endpointなどのクラウドセキュリティ技術の活用にも積極的に取り組んでいます。

今後はゼロトラストセキュリティの実装やクラウドセキュリティの専門性をさらに高め、CSIRT業務の上流工程にも携わりながら、組織全体のセキュリティレベル向上に貢献できるエンジニアを目指しています。

【職務経歴】
・株式会社Algomaticサイバーセキュリティ（2023年4月〜現在）
  ○ 会社概要：年商約30億円、従業員数150名のセキュリティサービス専業企業
  ○ 就業期間：2023年4月〜現在
  ○ 職務内容：SOCアナリスト（セキュリティ監視・運用業務）
    - 大手製造業のSOCチームに常駐し、24時間365日体制でのセキュリティ監視業務を担当
    - セキュリティログの収集・分析、アラートの検知・トリアージ、初期インシデント対応
    - Microsoft Defender for Endpoint、Azure Sentinelを活用した脅威検知と対応
    - SOCの運用プロセス改善、検知ルールの最適化による誤検知率の20%削減に貢献
    - マルウェア感染疑いの端末の調査・分析、フォレンジック初期対応
  ○ 使用した技術・ツール：Splunk、Microsoft Defender for Endpoint、Azure Sentinel、Wireshark
  ○ 身につけたスキル：セキュリティログ分析能力、インシデント対応プロセス、マルウェア解析の基礎知識

・株式会社Algomaticテクノロジーズ（2021年4月〜2023年3月）
  ○ 会社概要：年商約100億円、従業員数500名のITソリューション企業
  ○ 就業期間：2021年4月〜2023年3月
  ○ 職務内容：セキュリティエンジニア（導入・構築）
    - 金融機関向けにMicrosoft 365 E5 Securityの導入プロジェクトに参画
    - セキュリティ製品（Defender for Endpoint, Defender for Office 365等）の詳細設計・構築
    - セキュリティポリシーの策定支援、運用手順書の作成
    - クライアント向けセキュリティ教育資料の作成と教育実施
    - 脆弱性診断（Webアプリケーションおよびネットワーク）の実施と報告書作成
  ○ 使用した技術・ツール：Microsoft 365 E5 Security製品群、Nessus、OWASP ZAP、Burp Suite
  ○ 身につけたスキル：セキュリティ製品の設計・構築能力、脆弱性診断技術、ドキュメント作成力

・株式会社Algomatic情報システム（2020年4月〜2021年3月）
  ○ 会社概要：年商約50億円、従業員数250名のシステムインテグレーター
  ○ 就業期間：2020年4月〜2021年3月
  ○ 職務内容：ITインフラエンジニア（セキュリティ担当）
    - 社内ネットワークセキュリティ対策の実施（FW、IPS設定）
    - クライアントPCのセキュリティ対策ソフト導入・管理
    - 社内セキュリティ教育の企画・実施
    - 情報セキュリティインシデント発生時の初動対応
  ○ 使用した技術・ツール：Cisco ASA、Fortinet FortiGate、Trend Micro Apex One
  ○ 身につけたスキル：ネットワークセキュリティの基礎知識、セキュリティポリシー実装経験

【受賞・表彰歴】
・2023年度 株式会社Algomaticサイバーセキュリティ「優秀新人賞」受賞
 （SOC運用における検知ルール最適化プロジェクトでの貢献が評価）
・2022年 社内ハッキングコンテスト 3位入賞
 （WebアプリケーションのXSS脆弱性とSQLインジェクション脆弱性を発見）

【資格】
・情報処理安全確保支援士（登録セキスペ）（2023年4月）
・CISSP（2023年10月）
・CompTIA Security+（2022年5月）
・Azure Security Engineer Associate（AZ-500）（2022年8月）
・CCNA（2021年7月）
・情報セキュリティマネジメント試験（2020年10月）
・応用情報技術者試験（2020年4月）

【マネジメント経験】
・株式会社Algomaticサイバーセキュリティにて、新人教育担当として後輩2名の指導を担当（2023年7月〜現在）
・セキュリティ監視業務の手順書作成とトレーニングセッションの実施
・週次の振り返りミーティングを実施し、業務上の課題解決をサポート
・新人2名がSOC業務の基本スキルを3ヶ月で習得できるよう支援

【語学力】
・英語：ビジネスレベル（TOEIC 780点）
・技術文書の読解、海外ベンダーとのテクニカルミーティング対応可能
・セキュリティ関連の英語記事や技術文書を日常的に読み、最新動向をキャッチアップ
` as const;
